import { render, staticRenderFns } from "./RequireTreeMobile.vue?vue&type=template&id=4bd46c68&"
import script from "./RequireTreeMobile.vue?vue&type=script&lang=js&"
export * from "./RequireTreeMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports